import React from 'react'
import 'react-vertical-timeline-component/style.min.css'

import { motion } from 'framer-motion'

import { ProjectCard } from './ProjectCard.tsx'
import { ProjectsData } from './ProjectsData.ts'
import { pageVariants, pageTransition } from './FramerAnimation.ts'
import styles from './project.module.scss'

const Projects = () => {
  return (
    <div className={styles.projects}>
      <motion.div
        initial="init"
        animate="anim"
        exit="last"
        variants={pageVariants}
        transition={pageTransition}
      >
        <div className={styles.wrapper}>
          <div className={styles.projects_content}>
            {ProjectsData.map((item, index) =>
              index % 2 === 0 ? (
                <ProjectCard
                  key={item.title}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                  GitHub={item.GitHub}
                  hosted={item.hosted}
                />
              ) : (
                <ProjectCard
                  key={item.title}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                  GitHub={item.GitHub}
                  hosted={item.hosted}
                />
              )
            )}
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default Projects
